import { object, string, ref, array, mixed } from "yup";
import { messages } from "../constants/messages";

export const SNS_OPTIONS = [
  { value: "instagram", label: "Instagram" },
  { value: "x", label: "X（旧Twitter）" },
  { value: "facebook", label: "Facebook" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "youtube", label: "YouTube" },
  { value: "tiktok", label: "TikTok" },
  { value: "line", label: "LINE公式" },
  { value: "other", label: "その他" },
];

const passwordRegx = /^(?=.*\d)(?=.*[A-Z]).{8,}$/;

export const isFormComplete = (formData) => {
  return Object.values(formData).every((value) => !!value);
};

export const registerSchema = object().shape({
  name: string().required(),
  category: string().required(),
  password: string().required().matches(passwordRegx, messages.invalidPassword),
  confirmPassword: string()
    .required()
    .oneOf([ref("password"), null], messages.invalidConfirmPassword),
  email: string().email().required(),
});

export const loginSchema = object().shape({
  email: string().email().required(),
  password: string().required(),
});

export const resetPasswordSchema = object().shape({
  newPassword: string()
    .required()
    .matches(passwordRegx, messages.invalidPassword),
  confirmNewPassword: string()
    .required()
    .oneOf([ref("newPassword"), null], messages.invalidConfirmPassword),
});

export const forgotPasswordSchema = object().shape({
  email: string().email().required(),
});

// Issue #91: 構造化アイテムのサブフィールド定義（バックエンドと同値）
const goldenSeriesItemSchema = object({
  title: string().max(40),
  content: string().max(40),
  approach: string().max(40),
});

const powerWordItemSchema = object({
  title: string().max(20),
  content: string().max(40),
});

const itemProductSchema = object({
  title: string().max(20),
  url: string().max(500),
  content: string().max(40),
});

export const businessSheetSchema = object().shape({
  shortBiography: string().max(400),
  businessDescription: string().max(400),
  personalInformation: string().max(1000),
  goals: string().max(1000),
  accomplishments: string().max(1000),
  interests: string().max(1000),
  networks: string().max(1000),
  skills: string().max(1000),
  // Issue #91: 金のシリーズ／パワーワード／アイテムは構造化オブジェクト配列
  goldenEgg: array().of(goldenSeriesItemSchema).length(3),
  goldenGoose: array().of(goldenSeriesItemSchema).length(3),
  goldenFarmer: array().of(goldenSeriesItemSchema).length(3),
  companyStrengths: string().max(1000),
  powerWords: array().of(powerWordItemSchema).length(6),
  itemsProducts: array().of(itemProductSchema).length(3),
  links: array()
    .of(
      object({
        label: string().max(50),
        url: string()
          .max(500)
          .matches(
            /^(https?:\/\/.*)?$/,
            "URLはhttps://またはhttp://から始めてください",
          ),
      }),
    )
    .max(10),
  snsLinks: array()
    .of(
      object({
        platform: string().oneOf(SNS_OPTIONS.map((o) => o.value)),
        url: string()
          .max(500)
          .matches(
            /^https?:\/\/.+/,
            "URLはhttps://またはhttp://から始めてください",
          ),
      }),
    )
    .max(8),
  achievements: array()
    .of(
      object({
        title: string().max(100),
        description: string().max(500),
        imageUrl: string(),
      }),
    )
    .max(6),
  services: array()
    .of(
      object({
        title: string().max(100),
        description: string().max(500),
        imageUrl: string(),
      }),
    )
    .max(6),
  headerBackgroundImage: mixed().nullable(),
  profileImage: mixed().nullable(),
  referralSheetBackgroundImage: mixed().nullable(),
  colorPreference: string(),
  fontPreference: string(),
});
